import {
	CalendarSearch,
	Document,
	Hashtag,
	InfoCircle,
	SearchNormal,
	Send,
	Slash,
	Trash,
} from "iconsax-react";
// import moment from 'moment-jalaali';
import jalaali from "jalaali-js";
import debounce from "lodash.debounce";
import { MDBSpinner } from "mdb-react-ui-kit";
import React, { useContext, useEffect, useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import image from "../../assets/images/img_1.png";
import selectedUserImage from "../../assets/images/profile-circle.svg";
import returnIcon from "../../assets/images/redo.svg";
import { receiveUserError } from "../../Store/UserAction";
import { api } from "../../utils/axios";

function AddTaskModal({ show, setShow }) {
	const [searchedUser, setSearchedUser] = useState("");
	const [selectedUser, setSelectedUser] = useState(null);
	const [filteredUsers, setFilteredUsers] = useState([]);
	const [searchedList, setSearchedList] = useState([]);
	const [hintStep, setHintStep] = useState(0);
	const [disableBtn, setDisableBtn] = useState(true);
	const [loading, setLoading] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const [filePreview, setFilePreview] = useState(null);
	const [uploadingTask, setUploadingTask] = useState(false);
	const [values, setValues] = useState({
		title: "",
		description: "",
		deadline: "",
	});
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [dropdownOpen, setDropdownOpen] = useState(false);

	// Handle file selection
	const handleFileSelect = (event) => {
		const file = event.target.files[0];
		if (file) {
			// Validate file size (max 10MB)
			if (file.size > 10 * 1024 * 1024) {
				toast.error("حجم فایل نباید بیشتر از 10 مگابایت باشد");
				return;
			}

			// Validate file type
			const allowedTypes = [
				"application/pdf",
				"application/msword",
				"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
				"application/vnd.ms-excel",
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				"image/png",
				"image/jpeg",
				"image/jpg",
				"text/plain",
			];

			if (!allowedTypes.includes(file.type)) {
				toast.error(
					"فرمت فایل پشتیبانی نمی‌شود. فایل‌های مجاز: PDF، Word، Excel، تصاویر و متن",
				);
				return;
			}

			setSelectedFile(file);

			// Create preview for images
			if (file.type.startsWith("image/")) {
				const reader = new FileReader();
				reader.onload = (e) => {
					setFilePreview(e.target.result);
				};
				reader.readAsDataURL(file);
			} else {
				setFilePreview(null);
			}
		}
	};

	// Remove selected file
	const removeSelectedFile = () => {
		setSelectedFile(null);
		setFilePreview(null);
		// Reset file input
		const fileInput = document.getElementById("task-file-input");
		if (fileInput) {
			fileInput.value = "";
		}
	};

	// Get file icon based on type
	const getFileIcon = (fileType) => {
		if (fileType.startsWith("image/")) return "🖼️";
		if (fileType.includes("pdf")) return "📄";
		if (fileType.includes("word") || fileType.includes("document")) return "📝";
		if (fileType.includes("excel") || fileType.includes("spreadsheet"))
			return "📊";
		if (fileType.includes("text")) return "📄";
		return "📎";
	};

	// Format file size
	const formatFileSize = (bytes) => {
		if (bytes === 0) return "0 Bytes";
		const k = 1024;
		const sizes = ["Bytes", "KB", "MB", "GB"];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / k ** i).toFixed(2)) + " " + sizes[i];
	};

	// Helper to check if token is expired
	const isTokenExpired = (token) => {
		try {
			const payload = JSON.parse(atob(token.split(".")[1])); // Decode JWT
			const expTime = payload.exp * 1000; // Convert to milliseconds
			return Date.now() >= expTime; // Compare with current time
		} catch (error) {
			console.error("Error decoding token:", error);
			return true; // If decoding fails, assume the token is expired
		}
	};

	const searchBtnHandler = () => {
		const token = localStorage.getItem("token");
		if (!token || isTokenExpired(token)) {
			toast.warn("نشست شما منقضی شده است. لطفا دوباره وارد شوید.");
			localStorage.clear();
			navigate("/login");
			return;
		}
		api
			.get(`/searchUsers?query=${searchedUser}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				// Merge API response with Redux data to preserve profile_picture
				const apiUsers = res.data.users || [];
				const mergedUsers = apiUsers.map((apiUser) => {
					// Find matching user in Redux state to get profile_picture
					const reduxUser = userData.team_users.find(
						(reduxUser) => reduxUser.uid === apiUser.uid,
					);
					return {
						...apiUser,
						profile_picture:
							reduxUser?.profile_picture || apiUser.profile_picture,
					};
				});
				setFilteredUsers(mergedUsers);
			})
			.catch((err) => {
				console.error("Error fetching users:", err);
			});
	};

	const debouncedSearchUsers = React.useRef(
		debounce((query) => {
			if (!query || query.length < 2) {
				setFilteredUsers([]);
				return;
			}
			const token = localStorage.getItem("token");
			if (!token || isTokenExpired(token)) {
				toast.warn("نشست شما منقضی شده است. لطفا دوباره وارد شوید.");
				localStorage.clear();
				navigate("/login");
				return;
			}
			setLoading(true);
			api
				.get(`/searchUsers?query=${encodeURIComponent(query)}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					console.log("API search response:", res.data);
					console.log("API users:", res.data.users);
					if (res.data.users && res.data.users.length > 0) {
						console.log(
							"First API user profile_picture:",
							res.data.users[0].profile_picture,
						);
					}

					// Merge API response with Redux data to preserve profile_picture
					const apiUsers = res.data.users || [];
					const mergedUsers = apiUsers.map((apiUser) => {
						// Find matching user in Redux state to get profile_picture
						const reduxUser = userData.team_users.find(
							(reduxUser) => reduxUser.uid === apiUser.uid,
						);
						return {
							...apiUser,
							profile_picture:
								reduxUser?.profile_picture || apiUser.profile_picture,
						};
					});

					console.log("Merged users with profile_picture:", mergedUsers);
					setFilteredUsers(mergedUsers);
				})
				.catch((err) => {
					console.error("API search error:", err);
					setFilteredUsers([]);
				})
				.finally(() => setLoading(false));
		}, 400),
	).current;

	useEffect(() => {
		debouncedSearchUsers(searchedUser);
		// Cleanup debounce on unmount
		return () => debouncedSearchUsers.cancel();
	}, [searchedUser]);

	const handleSearchChange = (e) => {
		setSearchedUser(e.target.value);
		setDropdownOpen(true);
	};

	const handleUserSelect = (user) => {
		setSelectedUser(user);
		setSearchedUser(`${user.fname} ${user.lname}`);
		setDropdownOpen(false);
		setTimeout(() => setFilteredUsers([]), 200);
	};
	const [users, setUsers] = useState([]);
	const userData = useSelector((state) => state.user.data);

	console.log("userData: " + userData?.team_users);

	// useEffect(() => {
	//     // Fetch users from API
	//     api.get(`/searchUsers?query=${''}`, {
	//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
	//     }).then(res => {
	//         setUsers(res.data);
	//         console.log('users: ' + users)
	//     }).catch(err => {
	//         console.error(err);
	//     });
	// }, []);

	const fetchUserHints = (userQuery) => {
		console.log("User Query Type:", typeof userQuery);
		console.log("User Query Value:", userQuery);

		if (!userQuery || userQuery.length === 0) {
			console.warn("User Query is empty! Aborting API call.");
			return;
		}

		// 🔍 Get the token from localStorage
		const token = localStorage.getItem("token");
		if (!token) {
			console.warn("No token found. Redirecting to login.");
			toast.warn("دوباره وارد شوید.");
			localStorage.clear();
			navigate("/login"); // Redirect to login page
			return;
		}

		// 🔍 Check if the token is expired
		const isTokenExpired = (token) => {
			try {
				const payload = JSON.parse(atob(token.split(".")[1])); // Decode JWT
				const expTime = payload.exp * 1000; // Convert to milliseconds
				return Date.now() >= expTime; // Compare with current time
			} catch (error) {
				console.error("Error decoding token:", error);
				return true; // If decoding fails, assume the token is expired
			}
		};

		if (isTokenExpired(token)) {
			console.warn("Token is expired. Logging out.");
			toast.warn("نشست شما منقضی شده است. لطفا دوباره وارد شوید.");
			localStorage.clear();
			navigate("/login"); // Redirect to login page
			return;
		}

		setLoading(true);

		api
			.get(`/searchUsers?query=${encodeURIComponent(userQuery)}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				console.log("API Response:", res.data);
				const users = res.data.users || [];

				if (users.length > 0) {
					setSelectedUser({
						...users[0],
						hint: users[0].hint ? users[0].hint.split("\n\n") : [],
					});
				} else {
					console.warn("No users found for query:", userQuery);
					toast.warn("هیچ کاربری یافت نشد.");
				}
			})
			.catch((err) => {
				console.error("Error fetching user hints:", err);
				toast.error("خطا در دریافت اطلاعات کاربر.");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		console.log("searchedUser:", searchedUser);
		console.log("userData:", userData);

		if (searchedUser.length >= 2) {
			const filtered = userData.team_users.filter(
				(user) =>
					user.fname.toLowerCase().includes(searchedUser.toLowerCase()) ||
					user.lname.toLowerCase().includes(searchedUser.toLowerCase()),
			);
			console.log("filtered:", filtered);
			setFilteredUsers(filtered);
		} else {
			setFilteredUsers([]);
		}
	}, [searchedUser, userData]);

	// Add logging for filteredUsers changes
	useEffect(() => {
		console.log("filteredUsers updated:", filteredUsers);
		if (filteredUsers.length > 0) {
			console.log("First user in filteredUsers:", filteredUsers[0]);
			console.log(
				"First user profile_picture:",
				filteredUsers[0].profile_picture,
			);
		}
	}, [filteredUsers]);

	// Add logging for selectedUser changes
	useEffect(() => {
		console.log("selectedUser updated:", selectedUser);
		if (selectedUser) {
			console.log(
				"selectedUser profile_picture:",
				selectedUser.profile_picture,
			);
		}
	}, [selectedUser]);

	const handleUserChange = (user) => {
		console.log("Selected user:", user);
		setSelectedUser(user);
	};

	function closeModal() {
		setShow(false);
		setSelectedUser(null);
		setSearchedList([]);
		setSearchedUser("");
		setSelectedFile(null);
		setFilePreview(null);
		setUploadingTask(false);
		setValues({
			deadline: "",
			title: "",
			description: "",
		});
		setHintStep(0);
	}

	function changeHintStep(step) {
		switch (step) {
			case -1:
				if (hintStep > 0) setHintStep(hintStep - 1);
				break;
			case 1:
				if (hintStep < 8) setHintStep(hintStep + 1);
		}
	}

	useEffect(() => {
		if (values.description && values.deadline && values.title && selectedUser)
			setDisableBtn(false);
		else setDisableBtn(true);
	}, [values, selectedUser]);

	const submitForm = () => {
		if (values.description && values.deadline && values.title && selectedUser) {
			setUploadingTask(true);
			const { gy, gm, gd } = jalaali.toGregorian(
				values.deadline.year,
				values.deadline.month,
				values.deadline.day,
			);
			const formattedDeadline = `${gy}-${String(gm).padStart(2, "0")}-${String(gd).padStart(2, "0")}`;

			// Create FormData for multipart/form-data
			const formData = new FormData();
			formData.append("title", values.title);
			formData.append("description", values.description);
			formData.append("deadline", formattedDeadline);
			formData.append("assigned_user_id", selectedUser.uid);

			// Add file if selected
			if (selectedFile) {
				formData.append("file", selectedFile);
			}

			api
				.post("/add_task", formData, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("token")}`,
						"Content-Type": "multipart/form-data",
					},
				})
				.then((res) => {
					closeModal();
					toast.success("تسک با موفقیت اضافه شد!");
				})
				.catch((err) => {
					if (err.response && err.response.status === 401) {
						dispatch(receiveUserError(err.message));
					} else if (err.response?.data?.error) {
						toast.error(err.response.data.error);
					} else {
						toast.error("خطا در افزودن تسک.");
					}
				})
				.finally(() => {
					setUploadingTask(false);
				});
		} else {
			toast.error("لطفا همه فیلدها را پر کنید و یک کاربر را انتخاب کنید.");
		}
	};

	// Function to convert Arabic numerals to Latin numerals (to handle Persian numbers)
	function convertArabicToLatin(dateString) {
		const arabicToLatinMap = {
			"۰": "0",
			"۱": "1",
			"۲": "2",
			"۳": "3",
			"۴": "4",
			"۵": "5",
			"۶": "6",
			"۷": "7",
			"۸": "8",
			"۹": "9",
		};

		return dateString?.replace(
			/[\u0660-\u0669\u06F0-\u06F9]/g,
			(char) => arabicToLatinMap[char] || char,
		);
	}

	// Update the deadline handler to convert the selected date to UTC format
	// function deadLineChangeHandler(e) {
	//     // Convert the Persian date to Gregorian using moment-jalaali
	//     const gregorianDate = moment.from(e.format("YYYY-MM-DD"), 'fa', 'YYYY-MM-DD').toDate();

	//     // Format the Gregorian date to your desired format
	//     const formattedDate = gregorianDate.toUTCString(); // This will give you the desired format: Thu, 02 Jan 2025 00:00:00 GMT

	//     setDeadLine(formattedDate);
	//     setValues({ ...values, deadline: formattedDate });
	// }

	function convertArabicToLatin(dateString) {
		// نقشه برای تبدیل اعداد عربی به اعداد لاتین
		const arabicToLatinMap = {
			"۰": "0",
			"۱": "1",
			"۲": "2",
			"۳": "3",
			"۴": "4",
			"۵": "5",
			"۶": "6",
			"۷": "7",
			"۸": "8",
			"۹": "9",
		};

		// جایگزینی اعداد
		return dateString?.replace(
			/[\u0660-\u0669\u06F0-\u06F9]/g,
			(char) => arabicToLatinMap[char] || char,
		);
	}

	console.log("hint: ", selectedUser?.hint);

	return (
		<>
			{show && (
				<>
					<div className="fullscreen-modal-overlay" onClick={closeModal} />
					<div className="fullscreen-modal show">
						<div
							className="modal-box "
							onClick={(e) => e.stopPropagation()}
							style={{ direction: "rtl" }}
						>
							{/* Modal Title */}
							<h2 className="modal-title">افزودن تسک</h2>
							{/* Modal Content */}
							<div className="modal-content two-col-modal-content  tw-justify-evenly">
								{/* Right column: Form */}
								<form
									className="add-task-form form-col"
									onSubmit={(e) => {
										e.preventDefault();
										submitForm();
									}}
								>
									{/* User Search */}
									<div className="form-group">
										<label className="form-label">انجام دهنده:</label>
										<input
											className="form-input"
											type="text"
											placeholder="جستجوی کاربر"
											value={searchedUser || ""}
											onChange={handleSearchChange}
											style={{ paddingLeft: "2.2rem" }}
										/>
										<span className="input-icon input-icon-right">
											<SearchNormal size={20} color="#7a7e9d" />
										</span>
									</div>
									{/* User dropdown list */}
									{loading && (
										<div
											style={{
												color: "#7a7e9d",
												fontSize: 13,
												padding: "8px 0",
											}}
										>
											در حال جستجو...
										</div>
									)}
									{dropdownOpen && filteredUsers.length > 0 && (
										<ul className="user-dropdown-list">
											{filteredUsers.map((user) => (
												<li
													key={user.uid}
													className="user-dropdown-item"
													onMouseDown={() => handleUserSelect(user)}
												>
													<img
														src={
															user.profile_picture &&
															user.profile_picture.trim() !== ""
																? user.profile_picture
																: image
														}
														alt=""
														className="user-image-thumb"
													/>
													<span>
														{user.fname} {user.lname}
													</span>
													<span className="user-email">{user.email}</span>
												</li>
											))}
										</ul>
									)}
									{/* Deadline */}
									<div className="form-group">
										<label className="form-label">ددلاین:</label>
										<DatePicker
											calendar={persian}
											locale={persian_fa}
											calendarPosition="bottom-right"
											format={"YYYY/MM/DD"}
											inputClass="form-input"
											containerClassName="w-100"
											value={values.deadline}
											onChange={(date) =>
												setValues({ ...values, deadline: date })
											}
											style={{ width: "100%" }}
										/>
										<span className="input-icon input-icon-right">
											<CalendarSearch size={20} color="#7a7e9d" />
										</span>
									</div>
									{/* Description */}
									<div className="form-group">
										<label className="form-label">توضیحات:</label>
										<input
											className="form-input"
											type="text"
											placeholder="موضوع تسک"
											value={values.title}
											onChange={(e) =>
												setValues({ ...values, title: e.target.value })
											}
										/>
										<span
											className="input-icon input-icon-right"
											style={{ top: "24%" }}
										>
											<Hashtag size={20} color="#7a7e9d" />
										</span>
										<textarea
											className="form-textarea"
											placeholder="       جزئیات"
											value={values.description}
											onChange={(e) =>
												setValues({ ...values, description: e.target.value })
											}
											rows={5}
										/>
										{(!values.description ||
											values.description.length === 0) && (
											<span
												className="input-icon input-icon-right"
												style={{ top: "48%" }}
											>
												<InfoCircle size={20} color="#7a7e9d" />
											</span>
										)}
									</div>

									{/* File Upload */}
									<div className="form-group">
										<label className="form-label">فایل پیوست (اختیاری):</label>
										<div className="file-upload-container">
											<input
												id="task-file-input"
												type="file"
												accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt"
												onChange={handleFileSelect}
												className="file-input"
												style={{ display: "none" }}
											/>
											<label
												htmlFor="task-file-input"
												className="file-upload-btn"
											>
												<Document size={20} color="#7a7e9d" />
												انتخاب فایل
											</label>
										</div>

										{/* Selected file preview */}
										{selectedFile && (
											<div className="selected-file-preview">
												<div className="file-info">
													<span className="file-icon">
														{getFileIcon(selectedFile.type)}
													</span>
													<div className="file-details">
														<div className="file-name">{selectedFile.name}</div>
														<div className="file-size">
															{formatFileSize(selectedFile.size)}
														</div>
													</div>
													<button
														className="remove-file-btn"
														onClick={removeSelectedFile}
														type="button"
													>
														<Trash size={16} color="#ff4757" />
													</button>
												</div>
												{filePreview && (
													<div className="file-preview-image">
														<img src={filePreview} alt="Preview" />
													</div>
												)}
											</div>
										)}
									</div>

									{/* Submit Button */}
									<button
										className="submit-btn"
										type="submit"
										disabled={disableBtn || uploadingTask}
									>
										{uploadingTask ? (
											<MDBSpinner
												size="sm"
												color="white"
												style={{ marginLeft: 8 }}
											/>
										) : (
											<Send
												size={22}
												className="submit-btn-icon"
												color="#36B37E"
												style={{ marginLeft: 8 }}
											/>
										)}
										{uploadingTask ? "در حال آپلود..." : "تایید و افزودن تسک"}
									</button>
								</form>

								{/*Left column: Chosen items (only on desktop)*/}
								<div className="chosen-items-col tw-w-[400px]">
									{/* Show selected user, deadline, and description summary if available */}
									{selectedUser ? (
										<div className="selected-user-info-card">
											<div className="mbti-label">کاربر انتخاب شده:</div>
											<div className="selected-user-header">
												<img
													src={
														selectedUser.profile_picture &&
														selectedUser.profile_picture.trim() !== ""
															? selectedUser.profile_picture
															: image
													}
													alt=""
													className="selected-user-image"
												/>
												<div className="selected-user-details">
													<div className="selected-user-name">
														{selectedUser.fname} {selectedUser.lname}
													</div>
													<div className="selected-user-email">
														{selectedUser.email}
													</div>
												</div>
												<button
													className="remove-user-btn"
													onClick={() => setSelectedUser(null)}
													title="حذف کاربر"
												>
													✕
												</button>
											</div>
											<div className="selected-user-mbti-section">
												<div className="mbti-label">شخصیت این کاربر:</div>
												{selectedUser.mbti ? (
													<div className="mbti-card">
														<div className="flex tw-flex-row tw-justify-center tw-items-center tw-w-full">
															<span className="mbti-type">
																{selectedUser.mbti}
															</span>
														</div>
														{/*<div className="mbti-desc">{selectedUser.mbti_desc || 'سبک ارتباط: توضیحات شخصیت موجود نیست.'}</div>*/}
														{/* MBTI hint navigation if multiple hints */}
														{selectedUser.hint &&
															selectedUser.hint.length > 1 && (
																<div className="mbti-nav">
																	{/*<button className="mbti-nav-btn" onClick={() => setHintStep(hintStep - 1)} disabled={hintStep === 0}>{'<'}</button>*/}
																	<span className="mbti-hint">
																		{selectedUser.hint}
																	</span>
																	{/*<button className="mbti-nav-btn" onClick={() => setHintStep(hintStep + 1)} disabled={hintStep === selectedUser.hint.length - 1}>{'>'}</button>*/}
																</div>
															)}
														<a
															className="mbti-more-link"
															href={`https://www.16personalities.com/${selectedUser.mbti}-personality`}
															target="_blank"
															rel="noopener noreferrer"
														>
															برای اطلاعات بیشتر از تیپ شخصیتی{" "}
															{selectedUser.mbti} کلیک کنید.
														</a>
													</div>
												) : (
													<div className="mbti-card mbti-no-type">
														کاربر آزمون تست شخصیت را تکمیل نکرده است
													</div>
												)}
											</div>
										</div>
									) : (
										<div className="chosen-item chosen-user-empty">
											<Slash
												size={20}
												color="#7a7e9d"
												style={{ marginLeft: 8 }}
											/>
											هنوز کاربری انتخاب نشده است!
										</div>
									)}
									{/*{values.deadline && (*/}
									{/*  <div className="chosen-item chosen-deadline">*/}
									{/*    <span className="chosen-label">ددلاین:</span>*/}
									{/*    <span className="chosen-value">{values.deadline?.format?.("YYYY/MM/DD") || ""}</span>*/}
									{/*  </div>*/}
									{/*)}*/}
									{/*{values.title && (*/}
									{/*  <div className="chosen-item chosen-title">*/}
									{/*    <span className="chosen-label">موضوع:</span>*/}
									{/*    <span className="chosen-value">{values.title}</span>*/}
									{/*  </div>*/}
									{/*)}*/}
									{/*{values.description && (*/}
									{/*  <div className="chosen-item chosen-desc">*/}
									{/*    <span className="chosen-label">جزئیات:</span>*/}
									{/*    <p className="chosen-value " style={{whiteSpace:"pre-line"}}>{values.description}</p>*/}
									{/*  </div>*/}
									{/*)}*/}
									{selectedFile && (
										<div className="chosen-item chosen-file">
											<span className="chosen-label">فایل پیوست:</span>
											<div className="chosen-file-info">
												<span className="chosen-file-icon">
													{getFileIcon(selectedFile.type)}
												</span>
												<span className="chosen-file-name">
													{selectedFile.name}
												</span>
												<span className="chosen-file-size">
													({formatFileSize(selectedFile.size)})
												</span>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
						{/* Return Button - always last so it's on top */}
						<button
							className="return-btn"
							onClick={closeModal}
							type="button"
							style={{ direction: "rtl" }}
						>
							<img src={returnIcon} alt="بازگشت" className="return-icon" />
							<span>بازگشت به خانه</span>
						</button>
					</div>
				</>
			)}
		</>
	);
}

export default AddTaskModal;
